import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    regUserReportDataLoading: false,
    regUserReportDataSuccess: {},
    regUserReportDataError: "",
    userReportDataLoading: false,
    userReportDataSuccess: {},
    userReportDataError: "",
    courseRegUserReportDataLoading: false,
    courseRegUserReportDataSuccess: {},
    courseRegUserReportDataError: "",
}


export const regUserTypeSlice = createSlice({
    name: 'reg-user',
    initialState,
    reducers: {
        setRegUserReportDataLoading: (state, action) => {
            state.regUserReportDataLoading = true;
            state.regUserReportDataSuccess = {};
            state.regUserReportDataError = "";

        },
        setRegUserReportDataSuccess: (state, action) => {
            state.regUserReportDataLoading = false;
            state.regUserReportDataSuccess = action.payload;
            state.regUserReportDataError = "";
        },
        setRegUserReportDataError: (state, action) => {
            state.regUserReportDataLoading = false;
            state.regUserReportDataSuccess = {}
            state.regUserReportDataError = action.payload.message
        },
        setUserReportDataLoading: (state, action) => {
            state.userReportDataLoading = true;
            state.userReportDataSuccess = {};
            state.userReportDataError = "";

        },
        setUserReportDataSuccess: (state, action) => {
            state.userReportDataLoading = false;
            state.userReportDataSuccess = action.payload;
            state.userReportDataError = "";
        },
        setUserReportDataError: (state, action) => {
            state.userReportDataLoading = false;
            state.userReportDataSuccess = {}
            state.userReportDataError = action.payload.message
        },
        setCourseRegUserReportDataLoading: (state, action) => {
            state.courseRegUserReportDataLoading = true;
            state.courseRegUserReportDataSuccess = {};
            state.courseRegUserReportDataError = "";

        },
        setCourseRegUserReportDataSuccess: (state, action) => {
            state.courseRegUserReportDataLoading = false;
            state.courseRegUserReportDataSuccess = action.payload;
            state.courseRegUserReportDataError = "";
        },
        setCourseRegUserReportDataError: (state, action) => {
            state.courseRegUserReportDataLoading = false;
            state.courseRegUserReportDataSuccess = {}
            state.courseRegUserReportDataError = action.payload.message
        },
        
    },
})

// Action creators are generated for each case reducer function
export const { setRegUserReportDataLoading, setRegUserReportDataSuccess,setRegUserReportDataError,setUserReportDataLoading, setUserReportDataSuccess,setUserReportDataError,setCourseRegUserReportDataLoading,setCourseRegUserReportDataSuccess,setCourseRegUserReportDataError
} = regUserTypeSlice.actions

export default regUserTypeSlice.reducer;